(function(){"use strict";
function init(root){
 if(root.dataset.ttReviewsReady)return;root.dataset.ttReviewsReady="1";
 var modal=root.querySelector("[data-tt-review-modal]"),closeBtns=[].slice.call(root.querySelectorAll("[data-tt-review-close]"));
 var stars=[].slice.call(root.querySelectorAll("[data-tt-star]")),next=root.querySelector("[data-tt-review-next]"),submit=root.querySelector("[data-tt-review-submit]"),details=root.querySelector("[data-tt-review-details]"),progress=[].slice.call(root.querySelectorAll("[data-tt-review-step]"));
 if(!modal)return;
 var imageField=root.querySelector("[data-tt-review-photo-url]"),preview=root.querySelector("[data-tt-review-photo-preview]");
 if(imageField&&preview){imageField.addEventListener("input",function(){var val=imageField.value.trim();if(/^https:\/\/[^\s]+$/i.test(val)){preview.src=val;preview.hidden=false}else{preview.hidden=true;preview.removeAttribute("src")}});preview.addEventListener("error",function(){preview.hidden=true})}
 var last=null,selected=0;
 function steps(n){progress.forEach(function(x,i){x.classList.toggle("tt-current",i<n)})}
 function paint(n){stars.forEach(function(x,i){x.classList.toggle("tt-is-active",i<n)})}
 function open(){
  last=document.activeElement;modal.hidden=false;document.body.classList.add("tt-review-lock");
  steps(details&&!details.hidden?2:1);
  var focus=modal.querySelector("[data-tt-review-close]");if(focus)focus.focus();
 }
 function close(){
  if(modal.hidden)return;modal.hidden=true;document.body.classList.remove("tt-review-lock");if(last&&last.isConnected)last.focus();
 }
 document.querySelectorAll('[data-tt-review-open][aria-controls="'+modal.id+'"]').forEach(function(x){x.addEventListener("click",function(e){e.preventDefault();open()})});
 closeBtns.forEach(function(x){x.addEventListener("click",close)});
 document.addEventListener("keydown",function(e){
  if(modal.hidden)return;
  if(e.key==="Escape"){e.preventDefault();close();return;}
  if(e.key==="Tab"){
    var els=[].slice.call(modal.querySelectorAll('button:not([disabled]):not([hidden]),a[href],input:not([hidden]),textarea:not([hidden])')).filter(function(x){return x.offsetParent!==null});
    if(!els.length)return;
    if(e.shiftKey&&document.activeElement===els[0]){e.preventDefault();els[els.length-1].focus()}
    else if(!e.shiftKey&&document.activeElement===els[els.length-1]){e.preventDefault();els[0].focus()}
  }
 });
 stars.forEach(function(star){
  var input=star.querySelector("input");
  if(!input)return;
  input.addEventListener("change",function(){selected=Number(input.value);paint(selected);if(next)next.disabled=false});
  star.addEventListener("mouseenter",function(){paint(Number(input.value))});
  star.addEventListener("mouseleave",function(){paint(selected)});
 });
 if(next&&details){
  next.addEventListener("click",function(){
   if(!selected)return;details.hidden=false;next.hidden=true;if(submit)submit.hidden=false;steps(2);
   var input=details.querySelector("textarea");if(input)input.focus();
  });
 }
 if(modal.querySelector("[data-tt-review-success]")||modal.querySelector(".tt-review-modal__error")){open();if(details){details.hidden=false;steps(2);if(next)next.hidden=true;if(submit)submit.hidden=false}}
}
function scan(){document.querySelectorAll("[data-tt-reviews]").forEach(init)}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",scan);else scan();
document.addEventListener("shopify:section:load",scan);
})();